import { render, staticRenderFns } from "./default-loader.vue?vue&type=template&id=d600b2d6&scoped=true"
import script from "./default-loader.vue?vue&type=script&lang=js"
export * from "./default-loader.vue?vue&type=script&lang=js"
import style0 from "./default-loader.vue?vue&type=style&index=0&id=d600b2d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d600b2d6",
  null
  
)

export default component.exports